import styled from "@emotion/styled"

export const ReportFooter = styled.footer`
    background-color: rgba(255, 255, 255, 0.55);
    border-top: 1px solid #ffffff;
    backdrop-filter: blur(12px);
    padding: 16px 16px 34px 16px;
`
